/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isFunction, get, isString } from 'lodash';

// Components
import AssetPreview from 'shared/ui/components/uploader/AssetPreview.vue';
import BulkActions from 'shared/ui/components/listings/BulkActions.vue';
import ListActions from 'shared/ui/components/listings/ListActions.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';

// Custom actions components
import CopyPermalinkButton from 'shared/ui/components/listings/custom-actions/CopyPermalinkButton.vue';
import LeaderboardExportButton from 'shared/ui/components/listings/custom-actions/LeaderboardExportButton.vue';
import LeaderboardUpdateButton from 'shared/ui/components/listings/custom-actions/LeaderboardUpdateButton.vue';
import OpenModalAction from 'shared/ui/components/listings/custom-actions/OpenModalAction.vue';

// Custom cells components
import BadgeCell from 'shared/ui/components/listings/custom-cell/BadgeCell.vue';
import ScheduledJobsDeleteCell from 'shared/ui/components/listings/custom-cell/ScheduledJobsDeleteCell.vue';
import ScheduledJobsNodeCell from 'shared/ui/components/listings/custom-cell/ScheduledJobsNodeCell.vue';
import ScheduledJobsRefreshCell from 'shared/ui/components/listings/custom-cell/ScheduledJobsRefreshCell.vue';
import SendNotificationCell from 'shared/ui/components/listings/custom-cell/SendNotificationCell.vue';
import SessionRegistrationCell from 'shared/ui/components/listings/custom-cell/SessionRegistrationCell.vue';
import StringListCell from 'shared/ui/components/listings/custom-cell/StringListCell.vue';

const RETRIEVE_ALL_STRATEGY = 'retrieve_all';

const __vue_script__ = {
    name: 'FpTypedList',

    components: {
        AssetPreview,
        BulkActions,
        CopyPermalinkButton,
        BadgeCell,
        LeaderboardExportButton,
        LeaderboardUpdateButton,
        ListActions,
        LoaderButton,
        OpenModalAction,
        ScheduledJobsDeleteCell,
        ScheduledJobsNodeCell,
        ScheduledJobsRefreshCell,
        SearchBar,
        SendNotificationCell,
        SessionRegistrationCell,
        SmartTable,
        StringListCell,
    },

    props: {
        controller: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        module: {
            type: Object,
            required: true
        }
    },

    data() {
        const { resolvers, routeOptions } = this.controller;
        const { callToActions, crudOpts = {} } = routeOptions;

        const defaultResolver = resolvers.default || {};
        const { strategy, options: resolverOptions = {} } = defaultResolver;
        const { fpType } = resolverOptions;

        const showSearchBar = !resolverOptions.hideSearchBar;

        return {
            MAX_ITEMS_PER_PAGE: crudOpts.itemsPerPage || 25,
            callToActions,
            columns: crudOpts.columns,
            crudOpts,
            fpType,
            fullItems: [],
            fullSearchItems: undefined,
            hasFullLocalData: true,
            items: [],
            loading: false,
            metadata: {},
            page: 1,
            resolverOptions,
            searchTerm: '',
            showSearchBar,
            sort: 'ASC',
            sortBy: null,
            sortField: null,
            strategy,
            total: 0,
            selectable: !this.controller.notSelectable && !crudOpts.noBatchActions
        };
    },

    watch: {
        searchTerm() {
            if (this.hasFullLocalData) {
                this.localSearch();
            } else if (this.searchTerm.length >= 3 || this.searchTerm.length === 0) {
                this.loadData();
            }
        }
    },

    async created() {
        try {
            this.metadata = await this.$services.metadata.getMetadataForType(this.event._id, this.fpType);
            this.loadData();
        } catch (error) {
            console.error('[FpTypedList] Could not initialize:', error.message);
        }
    },

    methods: {
        /**
         * DATA LOADING
         */

        /**
         * Loads data for the component.
         *
         * @param {number} [page=1] - The page number to load data for. Defaults to 1 if not provided.
         */
        async loadData(page = 1) {
            try {
                if (page === 1) {
                    this.$refs.itemsTable.resetDisplay();
                }
                if (this.loading) {
                    return;
                }

                this.loading = true;

                if (this.resolverOptions.appscriptUrl) {
                    this.hasFullLocalData = !this.resolverOptions?.paginated;
                    const params = {
                        skip: this.hasFullLocalData ? 0 : this.MAX_ITEMS_PER_PAGE * (page - 1),
                        limit: this.hasFullLocalData ? 1000 : this.MAX_ITEMS_PER_PAGE
                    };
                    await this.loadWithAppscript(page, params);
                }

                if (this.strategy === RETRIEVE_ALL_STRATEGY) {
                    this.hasFullLocalData = true;
                    // For now we only load all with the document service, so we need to retrieve all, not just MAX_ITEMS.
                    // We need to put a number limit to override the default and 1k is way above most platform limits + we don't want to get more than 1k item in a single call.
                    await this.loadWithDocumentService(page, { limit: 1000 });
                }

            } catch (error) {
                console.error('[FpTypedList] Could not load data:', error.message);
            } finally {
                this.loading = false;
            }
        },

        /**
         * Asynchronously loads data using an Appscript.
         *
         * @param {number} page - The page number to load.
         * @param {Object} params - Additional parameters for the request.
         */
        async loadWithAppscript(page, params) {
            if (this.sort === 'DESC') {
                // Based on can/retrieve-page.js declaration.
                // This needs to be standardized in the future.
                params.reverse = true;
            }

            if (this.sortField) {
                params.sort = this.sortField;
            }

            if (this.searchTerm.length > 0) {
                params.search = this.searchTerm;
                delete params.skip;
                delete params.limit;
            }

            const appscriptResponse = await this.$services.appScripts.callAppScript(
                this.event._id,
                this.resolverOptions.appscriptUrl,
                params,
            );
            // the appscript may return an array of documents
            // or a "rows" key with an array of documents and "total_rows"
            let rows = [];
            let total_rows = 0;
            if (appscriptResponse.rows && appscriptResponse.total_rows) {
                rows = appscriptResponse.rows;
                total_rows = appscriptResponse.total_rows;
            } else if (Array.isArray(appscriptResponse)) {
                rows = appscriptResponse;
                total_rows = appscriptResponse.length;
            } else {
                console.error('[FpTypedList] Could not read appscript response:', appscriptResponse);
            }

            await this.decorateRows(rows);

            if (this.hasFullLocalData) {
                this.storeFullData(page, rows);
            } else {
                this.items = rows;
                this.total = total_rows;
                this.page = page;
            }
        },

        /**
         * Asynchronously loads data using the document service.
         *
         * @param {number} page - The page number to load.
         * @param {Object} params - Additional parameters for the document service.
         */
        async loadWithDocumentService(page, params) {
            const fpType = this.crudOpts.queryFpType || this.fpType;

            params.fields = this.resolverOptions.fields;
            params.cached = this.resolverOptions.preferCachedListResponse;

            const rows = await this.$services.documents.getAllDocsByType(this.event._id, fpType, params);
            await this.decorateRows(rows);
            this.storeFullData(page, rows);
        },

        /**
         * Store full data
         * @param {int} page - the page number
         * @param {Array} rows - The full data rows
         */
        storeFullData(page, rows) {
            this.fullItems = rows;
            this.total = this.fullItems.length;
            this.items = rows.slice(this.MAX_ITEMS_PER_PAGE * (page - 1), this.MAX_ITEMS_PER_PAGE * page);
            this.page = page;
        },

        /**
         * Decorates the rows of the component.
         *
         * @param {Array} rows - The rows to be decorated.
         */
        async decorateRows(rows) {
            try {
                for (const col of this.columns) {
                    if (!col.appscriptUrl) {
                        continue;
                    }

                    const params = {};

                    // col.params is built as { scriptParam: eachRowFieldProperty }
                    // meaning that "scriptParam" is the name of the parameter that the appscript expects
                    // and "eachRowFieldProperty" is the name of the property in each row that will be passed as the value
                    // making "scriptParam" an array of all the values of "eachRowFieldProperty"
                    for (const param of Object.keys(col.params)) {
                        params[param] = rows.map(row => row[col.params[param]]);
                    }

                    const data = await this.$services.appScripts.callAppScript(this.event._id, col.appscriptUrl, params);

                    rows.forEach(row => {
                        for (const param of Object.keys(col.params)) {
                            // Populate the row with the data from the appscript
                            // that must return an object with property with key the "eachRowFieldProperty" value
                            row[col.field] = data[row[col.params[param]]] || col.default;
                        }
                    });
                }
            } catch (error) {
                console.error('[FpTypedList] Could not decorate data:', error.message);
            }
        },

        /**
         * TABLE INTERRACTIONS
         */

        /**
         * Does a local search (used when we retrieve all elements)
         */
        localSearch() {
            this.$refs.itemsTable.resetDisplay();

            if (!this.searchTerm) {
                this.fullSearchItems = undefined;
                this.items = this.fullItems.slice(0, this.MAX_ITEMS_PER_PAGE);
            } else {
                const items = [];
                for (const item of this.fullItems) {
                    for (const column of this.columns) {
                        const value = get(item, column.field, '');
                        if (typeof value === 'string' && value.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase())) {
                            items.push(item);
                            break;
                        }
                    }
                }
                this.fullSearchItems = items;
                this.total = items.length;
                this.items = items.slice(0, this.MAX_ITEMS_PER_PAGE);
            }
            if (this.sortField) {
                this.localSort();
            }
        },

        /**
         * Does a local sort (used when all elements are here)
         */
        localSort() {
            const baseArray = this.fullSearchItems ?? this.fullItems;
            baseArray.sort((a, b) => {
                const aValue = get(a, this.sortField) || this.$refs[`${this.sortBy}_${a._id}`][0].innerText;
                const bValue = get(b, this.sortField) || this.$refs[`${this.sortBy}_${b._id}`][0].innerText;
                if (isString(aValue) && isString(bValue)) {
                    return this.sort === 'ASC'
                        ? aValue.localeCompare(bValue)
                        : bValue.localeCompare(aValue);
                } else if (typeof aValue === 'boolean' || typeof bValue === 'boolean') {
                    const order = aValue ? -1 : 1;
                    return this.sort === 'ASC' && (aValue === bValue) ? 0 : order;
                } else if (this.sort === 'ASC') {
                    return aValue - bValue;
                } else {
                    return bValue - aValue;
                }
            });
            this.items = baseArray.slice((this.page - 1) * this.MAX_ITEMS_PER_PAGE, this.page * this.MAX_ITEMS_PER_PAGE);
        },

        /**
         * Sets the sortable field and reload the collection
         *
         * @param {GenericListColumnConfig} cellConfig the configuration for the cell
         * @param {string} name the name of the cell
         */
        setSortable(cellConfig, name) {
            if (!cellConfig.sortable) {
                return;
            }

            const { sort, sortField } = this.$utils.tables.setSortable(cellConfig, this.sort, this.sortField);
            this.sort = sort;
            this.sortField = sortField;
            this.sortBy = name;

            if (this.hasFullLocalData) {
                this.localSort();
            } else {
                this.loadData();
            }
        },

        /**
         * Reloads the component asynchronously.
         */
        async onReload() {
            await this.$refs.itemsTable.unselectAll();
            await this.loadData();
        },

        /**
         * Handle page change.
         * @param page page number ( 1 based )
         */
        onPageChange(page) {
            if (this.hasFullLocalData) {
                this.page = page;
                const baseArray = this.fullSearchItems ?? this.fullItems;
                this.items = baseArray.slice((page - 1) * this.MAX_ITEMS_PER_PAGE, page * this.MAX_ITEMS_PER_PAGE);
            } else {
                this.loadData(page);
            }
        },

        /**
         * TABLE RENDERING
         */

        /**
         * Use "format" key of "cellConfig" to render the cell
         *
         * @param {GenericListColumnConfig} cellConfig
         * @param {Record<string, unknown>} item
         *
         * @returns {string|undefined} the formatted string, or undefined if could not be formatted
         */
        renderFormatted(cellConfig, item) {
            const format = cellConfig.format;
            if (isFunction(cellConfig.format)) {
                return cellConfig.format(item);
            }

            if (format === 'attachment') {
                const attachments = this.$utils.attachments.getAttachmentNames(item);
                return this.$utils.attachments.getAttachmentMetadata(item, attachments[0])?.content_type;
            }

            if (format === 'humanizeTimestamp') {
                const timestamp = get(item, cellConfig.field);
                return timestamp
                    ? this.$utils.time.tsToFormat(timestamp, 'LLL', this.event.timezone)
                    : '';
            }

            if (get(item, format)) {
                return get(item, format);
            }

            console.warn('[FpTypedList] Unknown cell formatter:', format);

            return undefined;
        },

        /**
         * Renders the cell with the given field and item
         *
         * @param {GenericListColumnConfig} cellConfig the configuration for the cell
         * @param {object} item the FP typed item
         *
         * @returns {string} a human readable version of the given field
         */
        render(cellConfig, item) {
            const formatted = cellConfig.format && this.renderFormatted(cellConfig, item);
            if (formatted) { return formatted; }

            const config = get(this.metadata, cellConfig.field);
            let value = get(item, cellConfig.field);

            if (config?.kind_options?.values?.hasOwnProperty(value)) {
                value = config.kind_options.values[value];
            } else if (!value && cellConfig.emptyFieldLabel) {
                value = this.$utils.strings.compileWithObject(cellConfig.emptyFieldLabel, item);
            }

            // If empty, return 'x'; otherwise, the value
            value = value ?? '×';
            if (isString(value)) {
                value = value.trim().length ? value : '×';
            } else {
                value = `${value}`;
            }

            return value;
        },

        /**
         * Compiles a link in the context of the given cell
         *
         * @param {GenericListLinkConfig} link the link for the cell
         * @param {object} item the FP typed item
         *
         * @returns {string} a compiled version of the link for this cell
         */
        cellLink(itemLink, item) {
            let module = this.module;
            if (itemLink.moduleName) {
                module = this.$services.blueprint.getModuleByName(itemLink.moduleName);
            }

            return this.$utils.tables.cellLink(itemLink, item, module, this.event);
        },

        /**
         * Generates the style for the content of a cell based on the cell configuration and item data.
         *
         * @param {GenericListColumnConfig} cellConfig - The configuration object for the cell.
         * @param {Object} item - The data item for the current row.
         *
         * @returns {Object} The style object to be applied to the cell content.
         */
        cellContentStyle(cellConfig, item) {
            if (!cellConfig.style) {
                return;
            }

            return this.$utils.strings.compileWithObject(cellConfig.style, item);
        },

        /**
         * Retrieves the subtext for a given item based on its cell configuration.
         *
         * @param {Object} cellConfig - The configuration object for the cell.
         * @param {Object} item - The item for which the subtext is to be retrieved.
         *
         * @returns {string} The subtext associated with the item.
         */
        getSubtext(cellConfig, item) {
            if (!cellConfig.subtext) {
                return;
            }

            if (Array.isArray(cellConfig.subtext.fields)) {
                return cellConfig.subtext.fields
                    .map(subtext => get(item, subtext))
                    .filter(Boolean)
                    .join(' · ');
            } else {
                return get(item, cellConfig.subtext.field);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fp-typed-list"},[_c('smart-table',{ref:"itemsTable",attrs:{"track-by":"_id","hide-pagination":_vm.searchTerm.length > 0 && !_vm.hasFullLocalData,"items-per-page":_vm.MAX_ITEMS_PER_PAGE,"items":_vm.items,"selectable":_vm.selectable,"total-items":_vm.total || _vm.items.length},on:{"next":_vm.onPageChange,"previous":_vm.onPageChange,"select-page":_vm.onPageChange},scopedSlots:_vm._u([{key:"filters",fn:function(ref){return [(_vm.showSearchBar)?_c('search-bar',{attrs:{"show-no-result":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}):_vm._e()]}},{key:"actions",fn:function(ref){return [_c('list-actions',{attrs:{"controller":_vm.controller,"module":_vm.module,"event":_vm.event,"metadata":_vm.metadata},on:{"reload":_vm.onReload}})]}},{key:"bulk-actions",fn:function(ref){
var selectedItems = ref.selectedItems;
return [_c('bulk-actions',{attrs:{"controller":_vm.controller,"module":_vm.module,"event":_vm.event,"selected-items":selectedItems},on:{"reload":_vm.onReload}})]}},{key:"headers",fn:function(ref){return _vm._l((_vm.columns),function(c){return _c('th',{class:_vm.$utils.tables.cellClasses(c).concat( _vm.$utils.tables.getCellSortClass(c, _vm.sort, _vm.sortBy)),on:{"click":function($event){return _vm.setSortable(c, c.field || c.label)}}},[_c('span',[_vm._v(_vm._s(_vm.$te(c.label) ? _vm.$t(c.label) : c.label))]),_c('i',{staticClass:"ic-icon"})])})}},{key:"row",fn:function(ref){
var item = ref.item;
return _vm._l((_vm.columns),function(c){return _c('td',{ref:((c.field || c.label) + "_" + (item._id)),refInFor:true,class:_vm.$utils.tables.cellClasses(c, item)},[(c.component)?_c(c.component,_vm._b({tag:"component",attrs:{"cell":c,"item":item,"event":_vm.event}},'component',c.props,false),[_vm._v(_vm._s(_vm.render(c, item)))]):(c.actions)?_vm._l((c.actions),function(action){return [(action.controllerKey)?_c('a',{staticClass:"btn",class:action.cssClass,style:(_vm.cellContentStyle(c, item)),attrs:{"href":_vm.cellLink(action, item),"disabled":!_vm.cellLink(action, item),"target":"_blank"}},[_vm._v(_vm._s(_vm.$te(action.label) ? _vm.$t(action.label) : action.label))]):_c(action.component,_vm._b({tag:"component",attrs:{"action":action,"cell":c,"item":item,"event":_vm.event}},'component',action.props,false))]}):[(c.link)?_c('a',{attrs:{"href":_vm.cellLink(c.link, item),"disabled":!_vm.cellLink(c.link, item)}},[_c('span',{style:(_vm.cellContentStyle(c, item))},[_vm._v(_vm._s(_vm.render(c, item)))])]):_c('span',{style:(_vm.cellContentStyle(c, item))},[_vm._v(_vm._s(_vm.render(c, item)))])],(_vm.getSubtext(c, item))?_c('div',{staticClass:"sub-text"},[_c('small',[_vm._v(_vm._s(_vm.getSubtext(c, item)))])]):_vm._e()],2)})}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FpTypedList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__